import * as React from "react";
import {Control, Field, Icon, TextArea} from "bloomer";
import Card from "../../../elements/Card";
import {getTextGenerationResult} from "../../../api/models/TextGeneration";
import Button from "../../../elements/Button";
import getWordsCount from "../../../utils/WordsCount";
import SendGAEvent, {GAEventActions, GAEventModels} from "../../../utils/SendGAEvent";
import WordsLabel from "../../../elements/WordsLabel";
import ErrorUtils from "../../../utils/ErrorUtils";
import {toast} from "react-toastify";
import ModelContentContainer from "../../../elements/ModelContentContainer";
import SectionName from "../../../elements/SectionName";
import FieldDescription from "../../../elements/FieldDescription";
import InputWarning from "../../../elements/InputWarning";
import Spacer from "../../../elements/Spacer";
import InformationCard from "../../../elements/InformationCard";
import {INVALID_FIELD_STYLE} from "../../../utils/Constants";

class TextGenerationModel extends React.Component {
  public state = {
    loading: false,
    textInput: "",
    textInputEmpty: false,
    result: "",
    wordsCount: 0,
    showLimitWarning: false,
    errorMessage: ""
  };

  public WORDS_LIMIT = 100;

  public componentDidMount() {
    SendGAEvent(GAEventActions.VIEW_MODEL, GAEventModels.TEXT_GENERATION);
  }

  public updateWordsCount = () => {
    const wordsCount = getWordsCount(this.state.textInput.trim());
    this.setState({
      wordsCount,
      showLimitWarning: wordsCount > this.WORDS_LIMIT
    });
  };

  public handleTextInputChange = (e:any) => {
    this.setState({
      textInput: e.target.value,
      textInputEmpty: false,
      errorMessage: ""
    }, () => {
      this.updateWordsCount();
    });
  };

  public onSubmit = async (e: any) => {
    e.target.blur();

    if (this.state.loading || !this.state.textInput.trim() || this.state.showLimitWarning) {

      this.setState({result: ""});

      if (!this.state.textInput.trim()) {
        this.setState({
          textInputEmpty: true
        });
      }

      return;
    }

    this.setState({
      loading: true,
      result: "",
      errorMessage: ""
    });

    let errorOccurred = false;

    const response = await getTextGenerationResult(this.state.textInput.trim()).catch((error) => {
      if (ErrorUtils.requestLimitExceeded(error.response)) {
        this.setState({
          loading: false
        });
        toast.error(ErrorUtils.messageContent.REQUEST_LIMIT_EXCEEDED);
      } else {
        this.setState({
          loading: false,
          errorMessage: "Unable to generate text."
        });
      }
      errorOccurred = true;
    });

    if (errorOccurred) {
      return;
    }

    if (ErrorUtils.requestLimitExceeded(response)) {
      this.setState({
        loading: false,
        errorMessage: ErrorUtils.message.REQUEST_LIMIT_EXCEEDED
      });
      return;
    }

    let result = "";
    if (response && response.data.length) {
      result = response.data.map((data: any) => {
        return data.generated_text || "";
      }).join(" ");
    }

    if (result) {
      this.setState({
        loading: false,
        result
      });
    } else {
      this.setState({
        loading: false,
        errorMessage: "Unable to generate text."
      });
    }

    SendGAEvent(GAEventActions.CALL_MODEL, GAEventModels.TEXT_GENERATION);
  };

  public resetState = async (e: any) => {
    e.target.blur();

    this.setState({
      loading: false,
      textInput: "",
      textInputEmpty: false,
      result: "",
      wordsCount: 0,
      showLimitWarning: false,
      errorMessage: ""
    });
  };

  public render() {
    return (
      <ModelContentContainer>
        <Card>
          <div>
              <Field>
                <Control>
                  <SectionName>Text</SectionName>
                  <FieldDescription>Maximum size of input is 100 words.</FieldDescription>
                  <TextArea
                      style={(this.state.textInputEmpty || this.state.showLimitWarning) ? INVALID_FIELD_STYLE : undefined}
                      onChange={this.handleTextInputChange}
                      onPaste={this.handleTextInputChange}
                      value={this.state.textInput}
                      placeholder="Enter original text here"
                  />
                  <div>
                    {
                      this.state.textInputEmpty && <InputWarning>Please input a text.</InputWarning>
                    }
                    {
                      this.state.showLimitWarning && <InputWarning>Input size limit has been exceeded. Please decrease the size.</InputWarning>
                    }
                    <WordsLabel>{this.state.wordsCount}&nbsp;{this.state.wordsCount > 1 ? 'words' : 'word'}</WordsLabel>
                  </div>
                </Control>
              </Field>
            </div>
          <Spacer/>
          <Spacer/>
          <div>
            <Button onClick={this.onSubmit}>Submit</Button>
            <Button onClick={this.resetState} style={{ marginLeft: "5px" }}>Reset</Button>
          </div>
          {this.state.loading && (
              <div>
                <Spacer/>
                <span>Loading...</span>
                <Icon className="fas fa-spinner fa-spin" />
              </div>
          )}
          {this.state.result && !this.state.loading && (
              <div>
                <Spacer/>
                <SectionName>Generated Text</SectionName>
                <InformationCard>
                  <div>{this.state.result}</div>
                </InformationCard>
              </div>
          )}
          {
            this.state.errorMessage && !this.state.loading && (<div>
              <Spacer/>
              <InformationCard>{this.state.errorMessage}</InformationCard>
            </div>)
          }
        </Card>
      </ModelContentContainer>
    );
  }
}

export default TextGenerationModel;



// WEBPACK FOOTER //
// ./src/routes/Dashboard/TextGeneration/TextGenerationModel.tsx